import { render, staticRenderFns } from "./bigPackageDetailLs.vue?vue&type=template&id=8306adb8&scoped=true&"
import script from "./bigPackageDetailLs.vue?vue&type=script&lang=js&"
export * from "./bigPackageDetailLs.vue?vue&type=script&lang=js&"
import style0 from "./bigPackageDetailLs.vue?vue&type=style&index=0&id=8306adb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8306adb8",
  null
  
)

export default component.exports